import React, { Component } from 'react';
import "./textAndImage.css";
import { Link } from "react-router-dom";

export default class extends Component {
  constructor(props) {
      super(props);
      this.state = {
          componentReady: 'ready'
      };
  }

  render() {
    var ratioImage = "/images/square.png"
    if(this.props.ratio != "square"){
      ratioImage = "/images/rectangle.png"
    }
    var direction = "right";
    if(this.props.direction === "left"){
      direction = "left";
    }
    var resizeMode = "cover";
    if(this.props.resizeMode === "contain"){
      resizeMode = "contain";
    }
    let textColor;
    let backgroundStyle;
    let textStyle;
    if(this.props.theme == "dark"){
      textStyle = {color:"#fff"};
      backgroundStyle = {backgroundColor:"#000"};
    }
    return (
      <div className={'text-and-image-container'} style={backgroundStyle}>
        <div className={`row ${ this.props.direction }`}>
          <div className="small-12 medium-6">
            <img className="full-width" src={ratioImage} style={{backgroundImage: `url(${ this.props.image })`,backgroundSize:resizeMode,backgroundPosition:'center',backgroundRepeat:'no-repeat'}} />
          </div>
          <div className="small-12 medium-6 row text-and-image-padding" style={{alignItems:'center',justifyContent:'center'}}>
            <div className="full-width" style={{margin:"auto"}}>
              {this.props.title && <h4 style={textStyle}>{this.props.title}</h4>}
              {this.props.description && <div style={{marginTop:'20px'}}><p className="subheading" style={textStyle}>{this.props.description}</p></div>}
              <div style={{"marginTop":"20px"}}>
                <div style={textStyle}>
                  {this.props.content && this.props.content}
                </div>
              </div>
              {this.props.buttonLink && <Link className="primary-background white button" to={this.props.buttonLink} style={{"marginTop":"20px"}}>{this.props.buttonText}</Link>}
              {this.props.hrefLink && <a className="button" target="_blank" href={this.props.hrefLink} style={{"marginTop":"20px"}}>{this.props.buttonText}</a>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/alpineComponents/textAndImage/index.js